<template>
  <div>
    <headerBreadCrumbs :breadCrumbs="breadCrumbs" title="Mass Notification" />

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left mb-4">
          <div class="card-body">
            <div class="d-flex flex-row justify-content-between mb-3">
              <h4 class="card-title">
                Mass Notification
              </h4>

              <Button :button="{ name: 'Add New', type: 'router', path: '/marketing/mass-notification/add' }" />
            </div>

            <div class="px-3">
              <ul class="list-group" v-for="(note, index) in notes" :key="index">
                <div class="d-flex flex-row">
                  <li v-if="!collapse && index == 0">{{ note.title }}</li>
                  <li v-if="collapse">{{ note.title }}</li>
                  <span v-if="index == 0" class="ml-5 custom-link" @click="collapse = !collapse" v-show="!collapse">Read
                    more</span>
                  <span v-if="index == notes.length - 1" class="ml-5 custom-link" @click="collapse = !collapse"
                    v-show="collapse">Read less</span>
                </div>
                <div class="ml-4" v-if="note.children && collapse" v-for="(child, childIndex) in note.children">
                  <span v-html="`${childIndex + 1}. ${child.text}`"></span>
                  <ul v-if="child.sub_children" class="list-group ml-5 my-2"
                    v-for="(sub_child, subChildIndex) in child.sub_children" :key="subChildIndex">
                    <li>{{ sub_child }}</li>
                  </ul>
                </div>
                <span v-if="note.child_note && collapse">{{ `Notes: ${note.child_note}` }}</span>
              </ul>
            </div>

            <hr />
            
            <DateFiltered :filterDate="filterDate" @resetData="fetchData" />
            <br />
            <MassNotification :table_id="'mass-notification-tbl'"  :massNotifications="massNotifications" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBreadCrumbs from '../../../components/headerBreadCrumbs.vue';
import Button from '../../../components/UI/Button.vue';
import { getMassNotification } from '../../../services/MassNotificationService';
import MassNotification from './mass-notification.vue';
import DateFiltered from '../../../components/dateFilter.vue'

export default {
  components: { headerBreadCrumbs, Button, MassNotification, DateFiltered },

  data() {
    return {
      collapse: false,
      notes: [
        {
          title: "On the specified period and time, the following will be automatically sent and displayed to all registered users listed in the Excel file uploaded via the Admin Dashboard:",
          child_note: null,
          children: [
            { text: "A daily <u>push notification.</u>", sub_children: ['No need login for push notification. However, if user happened to uninstall the app, they may not receive the push notification.'] },
            { text: "<u>In-app notification on the first day only.</u>", sub_children: ['In-app notification will be displayed for 14 days only.'] }
          ]
        },
        {
          title: "If admin chose to send SMS notification for those who are not registered but listed in the Excel file uploaded via the Admin Dashboard, they will automatically receive an SMS notification (one-time only).",
          child_note: null,
          children: null
        },
        {
          title: "Admin may also send SMS notification to the individual users manually.",
          child_note: null,
          children: null
        },
        {
          title: "Those with invalid phone numbers will not receive the SMS notification.",
          child_note: "SMS quota is shared for all TBM related activities.",
          children: null
        },
        {
          title: "If any of the registered users listed in the Excel do any new or renewal purchases within the set period, they will automatically be awarded the set Takaful Points upon successful purchase (except for type None).",
          child_note: null,
          children: null
        },
      ],

      breadCrumbs: [
        { name: 'Marketing', path: null },
        { name: 'Mass Notification', path: null },
      ],

      massNotifications: []
    }
  },

  watch: {
    massNotifications: {
      handler(newMassNotification) {
        this.initializeCurrentTable();
      },
      deep: true
    },
  },

  methods: {
    async fetchData(extraRequest = null) {
      this.massNotifications = [];
      try {
        const response = await getMassNotification(extraRequest);

        if (response.data.success) {
          this.massNotifications = response.data.data;
        }
      } catch (e) {
        console.error(e);
      }
    },

    async filterDate(from, to) {
      try {
        if (from != null && to != null)
        await this.fetchData({ from, to });
      } catch (e) {
        console.error(e);
      }
    },

    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        order: [],
        columns: [
          { orderable: false },
          { orderable: false }, 
          { orderable: false },  
          { orderable: false },
          { orderable: false }, 
          { orderable: false }  
        ],
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5],
              modifier: {
                page: 'all'
              }
            }
          }
        ]
      });
    },

    initializeCurrentTable() {
      ['mass-notification-tbl'].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`).DataTable().destroy();
        }
      });

      this.$nextTick(() => {
        this.loadDatatable('mass-notification-tbl');
      });
    },

  },

  async mounted() {
    await this.fetchData();
  },
}

</script>

<style scoped>
.custom-link {
  text-decoration: underline !important;
  color: #AC8400;
}

.custom-link:hover {
  cursor: pointer !important;
}
</style>
